//node-modules
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import {
  createContext,
  useEffect,
  useRef,
  useState,
  useContext,
  Dispatch,
  SetStateAction,
} from "react";
import { useTranslation } from "react-i18next";
import axios, { AxiosResponse } from "axios";
//common
import { Common } from "../../common/src/index";
import { devLog } from "../utility/devLog";
// css
import "../../css/buttonTheme.css";
//src
import NavBar from "../components/NavBar";
import PointCloudViewer from "../components/ProjectDetail/PointCloudViewer";
import Photos from "../components/ProjectDetail/Photos";
import { MsgSnackbar } from "../components/MsgSnackbar";
import { MsgErrSnackbar } from "../components/MsgErrSnackbar";
import ProjectState from "../components/ProjectDetail/projectState";
import { Viewer } from "../viewer/viewer";
import { config } from "../config/config";
import "../locales/i18n";
import { TProjectionMode } from "../viewer/utils/camera-utils";
// mui
import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  Fade,
  useTheme,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import AlignmentIcon from "../../images/icons/white_edit/DocumentExport_white.svg";

import RegisterWithDashboard from "../components/ProjectDetail/Dialogs/RegisterWithDashboard";
import RegisterWithLLV from "../components/ProjectDetail/Dialogs/RegisterWIthLLV";
import RegisterWithPointworks from "../components/ProjectDetail/Dialogs/RegisterWithPointworks";
import ProjectDetailDialog from "../components/ProjectDetail/Dialogs/ProjectDetailDialog";
import ExportData from "../components/ProjectDetail/Dialogs/ExportDataDialog";
import MsgWarnSnackbar from "../components/MsgWarnSnackbar";
import { userSetting } from "../../common/src/modules";
import { UserSiteContext, useThemeMode } from "../..";
import { MenuBar } from "../components/ProjectDetail/MenuBar/MenuBar";
import { ToolBar } from "../components/ProjectDetail/ToolBar/ToolBar";
import { Q3DBottomDrawer } from "../components/ProjectDetail/BottomDrawer/Q3DBottomDrawer";
import { HelmContextProvider } from "../components/ProjectDetail/Contexts/HelmContext";
import { IfcPlacementPanel } from "../components/ProjectDetail/IfcPlacement/IfcPlacementPanel";
import { IfcObjectGizmo } from "../components/ProjectDetail/IfcPlacement/IfcObjectGizmo";
import CalcContext, {
  CalcContextProvider,
} from "../components/ProjectDetail/Contexts/CalcContext";
import SettingDialog from "../components/Home/SettingDialog";
import DeleteProjectDialog from "../components/DeleteProjectDialog";
import DeleteAllPointsDialog from "../components/ProjectDetail/Dialogs/DeleteAllPointsDialog";
import { CoordinateContextProvider } from "../components/ProjectDetail/Contexts/CoordinateContext";
import ProcessCompletedDialog from "../components/ProcessCompletedDialog";
import { UpdateInfoContextProvider } from "../components/ProjectDetail/Contexts/UpdateInfoContext";
import { RemoveContextProvider } from "../components/ProjectDetail/Contexts/RemoveContext";
import {
  DETAIL_TAB,
  EDialogType,
  EDisplayType,
  EViewerMode,
  GAObj,
  IEnabledUpdateProjectDetail,
  LoadingStatus,
  PollingContext,
  PollingIds,
  PROCESS,
  ProcessIds,
  ProcessResult,
  ProjectDetailContext,
  resErrCode,
  RESULT,
  TProjectDetailContext,
  UseSnackbarContext,
} from "../components/ProjectDetail/Interfaces/ProjectDetailInterfaces";
import { projectARFileApis } from "../api/project";
import { IFC_LAYOUT_CHANGED_EVENT } from "../components/ProjectDetail/ToolBar/IfcTabPanel";
import ExportARData from "../components/ProjectDetail/Dialogs/ExportARDataDialog";
import { ViewerContext } from "../viewer/context";
import GaussianSplattingViewer from "../components/ProjectDetail/GaussianSplattingViewer";

const viewer = new Viewer();
// self-test / debug hook: expose the viewer so a headless test can drive placement
// coordinate logic without mouse simulation or the GPU sampler.
if (typeof window !== "undefined") (window as any).__designViewer = viewer;

const ProjectARView = () => {
  // プロジェクトIDを取得
  const { projectId } = useParams();
  const navigate = useNavigate();

  // search condition from Home
  const location = useLocation();

  // 多言語対応
  const { t, i18n } = useTranslation();

  const pointCloudViewerRef = useRef<any>();

  /*****************************************
   context
  ******************************************/
  const {} = useContext(CalcContext);

  /*****************************************
   state
  ******************************************/
  // value
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [pollingCallback, setPollingCallback] = useState<() => void>(
    () => () => {},
  );
  const [projectDetail, setProjectDetail] = useState<Common.ProjectDetail>(); // プロジェクト詳細情報
  const [processIds, setProcessIds] = useState<ProcessIds>({
    ar: null,
  } as ProcessIds);
  const [userSettings, setUserSettings] = useState<Common.userSetting>();
  const [projectName, setProjectName] = useState<string>("");
  const [GAValue, setGAValue] = useState<GAObj>({
    jobsiteId: null,
    userId: null,
    corporationId: null,
  } as GAObj);
  const { userInfo } = useContext(UserSiteContext);

  // snackbar
  const [openSuccess, setOpenSuccess] = useState<boolean>(false); // Success snackbar
  const [msgSuccess, setMsgSuccess] = useState<string>(""); // Success snackbar
  const [openWarnig, setOpenWarning] = useState<boolean>(false); // Warning snackbar
  const [msgWarning, setMsgWarning] = useState<string>(""); // Warning snackbar
  const [openError, setOpenError] = useState<boolean>(false); // Error snackbar
  const [msgError, setMsgError] = useState<string>(""); // Error snackbar

  // UI
  const [initDone, setInitDone] = useState<boolean>(false); // 画面初期化 or 強制初期化
  const [isJapanese, setIsJapanese] = useState<boolean>(false); // language is japanese?
  const [currentPointCloud, setCurrentPointCloud] =
    useState<Common.POINT_CLOUD_TYPE>(); // current point cloud type
  const [detailTab, setDetailTab] = useState<DETAIL_TAB>(); // current point cloud Tab
  const [whilePointCloudLoading, setWhilePointCloudLoading] =
    useState<boolean>(false);
  const [openProjectState, setOpenProjectState] = useState<boolean>(false); // project state
  const [toolBarShow, setToolBarShow] = useState<boolean>(true); // toolbox
  const [detailDataLoadingStatus, setDetailDataLoadingStatus] =
    useState<LoadingStatus>(LoadingStatus.Loading); // loading status
  const [errorDetailsStatus, setErrorDetailsStatus] = useState<number>(); // error status
  const [pix4dErrorMessage, setPix4dErrorMessage] = useState<string>(); // error code
  const [pix4dErrorCode, setPix4dErrorCode] = useState<number>(); // error code
  const { themeMode, setThemeMode } = useThemeMode();
  const pollingIdsRef = useRef<PollingIds>({
    ar: null,
  } as PollingIds);

  const isIosView =
    window.location.pathname.includes("/ios/") ||
    window.location.pathname.includes("/ios-ar/");
  const isArView =
    window.location.pathname.includes("/ar/") ||
    window.location.pathname.includes("/ios-ar/");

  // test
  const [bottomOpen, setBottomOpen] = useState(true);
  const headerHeight = "40px";
  const menubarHeight = "56px";
  const toolbarHeight = "48px";
  const viewerHeight = `calc(100vh - ${
    !isIosView ? headerHeight : "0px"
  } - ${menubarHeight} - ${toolbarHeight})`;

  // mode

  const [currentViewerMode, setCurrentViewerMode] = useState<EViewerMode>(
    EViewerMode.DEFAULT,
  ); // 計測/座標変換/点群除去/エクスポート

  const [showGsplat, setShowGsplat] = useState<boolean>(false);
  const [showIfcPutObject, setShowIfcPutObject] = useState<boolean>(false);
  const [selectedIfcObjectId, setSelectedIfcObjectId] = useState<string | null>(
    null,
  );
  const [selectedIfcObjectUrl, setSelectedIfcObjectUrl] = useState<
    string | null
  >(null);
  const [selectedIfcObjectName, setSelectedIfcObjectName] = useState<
    string | null
  >(null);

  const [currentDialog, setCurrentDialog] = useState<EDialogType>(
    EDialogType.NONE,
  ); // dialog

  const [processResult, setProcessResult] = useState<ProcessResult>({
    id: null,
    process: null,
    result: null,
  } as ProcessResult);
  const [openProcessCompletedDialog, setOpenProcessCompletedDialog] =
    useState<boolean>(false);

  /*****************************************
   Effect
   ******************************************/
  useEffect(() => {
    setIsJapanese(i18n.language === "ja");
  }, [i18n.language]);

  // init/force reload
  useEffect(() => {
    if (initDone) return;
    try {
      if (config.licenseCheck) {
        axios
          .get(`${config.serverHost}/api/v1/user/licenses`, {
            withCredentials: true,
          })
          .then((response) => {
            const landlogLicenseStatus: Common.LandlogLicenseStatus =
              response.data;
            const numOfLicenses = landlogLicenseStatus.numOfLicenses;

            if (config.licenseCheck) {
              if (0 < numOfLicenses) {
                getProjectCookie().then(() => {
                  Promise.all([getProjectDetail(), getUserSettings(true)]);
                });
              } else {
                openErrorSnackbar(t("LICENSE_ERROR"));
                setTimeout(function () {
                  window.location.href = `${config.serverHost}/login?displayType=web`;
                }, 2000);
              }
            }
          })
          .catch((err) => {
            openErrorSnackbar(t("LICENSE_ERROR"));
            setTimeout(function () {
              window.location.href = `${config.serverHost}/login?displayType=web`;
            }, 2000);
          });
      } else {
        getProjectCookie().then(() => {
          Promise.all([getProjectDetail(), getUserSettings(true)]);
        });
      }
    } catch {
    } finally {
      setInitDone(true);
    }
  }, [initDone]);

  useEffect(() => {
    const { dataLayer } = window;

    const areAllNotNull = (obj: Object) => {
      return Object.values(obj).every((value) => value !== null);
    };

    if (areAllNotNull(GAValue)) {
      dataLayer.push({
        event: "sc_jobsite_open", // イベント名
        sc_site_id: GAValue?.jobsiteId,
        sc_user_id: GAValue?.userId,
        sc_corporation_id: GAValue?.corporationId,
      });
    }
  }, [GAValue]);

  useEffect(() => {
    viewer.Resize();
  }, [bottomOpen]);

  const [projectionMode, setProjectionMode] = useState<TProjectionMode>(
    userSettings?.projectionDefault ? "perspective" : "orthographic",
  );

  useEffect(() => {
    const abortController = new AbortController();

    if (processIds.ar) {
      pollingIdsRef.current.ar = window.setInterval(() => {
        let hostName = config.serverHost.includes("localhost")
          ? "http://localhost:9090/quick3d"
          : config.serverHost;
        const url = `${hostName}/project_${projectId}/history/${processIds.ar}.process`;

        axios
          .get(url, {
            responseType: "json",
            signal: abortController.signal,
          })
          .then((response) => {
            const jsonData = response?.data;

            const id: string = processIds.ar;
            const result: RESULT = jsonData.result;
            const process: PROCESS = jsonData.process;
            setProcessResult({ id, process, result });
            setOpenProcessCompletedDialog(true);
            window.clearInterval(pollingIdsRef.current.ar);
          })
          .catch((err) => {
            // console.log(err);
          });
      }, 10000); // 10s
    }
    return () => {
      window.clearInterval(pollingIdsRef.current.sfm);
      window.clearInterval(pollingIdsRef.current.helmert);
    };
  }, [processIds]);

  useEffect(() => {
    setProjectionMode(
      userSettings?.projectionDefault ? "perspective" : "orthographic",
    );
  }, [userSettings]);

  useEffect(() => {
    if (!viewer) return;

    if (viewer.isCameraInit()) viewer.setProjectionMode(projectionMode);
  }, [projectionMode, viewer.isCameraInit()]);

  useEffect(() => {
    try {
      viewer?.Resize();
    } catch {}
  }, [toolBarShow]);

  useEffect(() => {
    if (isInitialized) return;

    if (projectDetail && projectDetail.las_file) {
      setCurrentPointCloud(Common.POINT_CLOUD_TYPE.AR);
      setIsInitialized(true);
    }
  }, [projectDetail]);

  useEffect(() => {
    if (projectDetail) {
      const apiUrl = `${config.serverHost}/api/v1/user/setting`;
      axios
        .get(apiUrl, { withCredentials: true })
        .then((res: AxiosResponse<any>) => {
          if (res.data && res.data.pointCloudBgcolor !== null) {
            viewer.setBackgroundColor(
              res.data.pointCloudBgcolor,
              res.data.pointCloudBgalpha,
            );
          }
        })
        .catch((e: any): void => {
          console.error(e);
          return undefined;
        });
    }
  }, [projectDetail]);

  useEffect(() => {
    if (viewer && userSettings?.pointCloudBgcolor) {
      const colorHex = userSettings.pointCloudBgcolor;
      const alpha = userSettings.pointCloudBgalpha ?? 1;
      const colorInt = parseInt(colorHex.substring(1), 16);

      viewer.setBackgroundColor(colorInt, alpha);
    }
  }, [viewer, userSettings, detailTab]);

  useEffect(() => {
    return () => {
      console.log("unmount");
      setIsInitialized(false);
    };
  }, []);

  /*****************************************
  function
  ******************************************/
  const updateOpenProcessCompletedDialog = (flag: boolean) => {
    setOpenProcessCompletedDialog(flag);
  };

  const closeProcessCompletedDialog = () => {
    updateOpenProcessCompletedDialog(false);
  };

  const updateProcessIds = (processIds: ProcessIds) => {
    setProcessIds(processIds);
  };

  const reloadPointCloud = () => {
    pointCloudViewerRef?.current?.reloadPointCloud();
  };

  // プロジェクト詳細更新
  const updateProjectDetail = (newDetail: IEnabledUpdateProjectDetail) => {
    if (newDetail.name) {
      setProjectName(newDetail.name);
      document.title = newDetail.name;
    }
    setProjectDetail((prev) => {
      if (!prev) return prev;
      const updated: any = { ...prev };
      const statusKeys = [
        "helmert_transformation",
        "coordinate_transformation",
        "point_splitting_lidar",
        "point_splitting_sfm",
        "point_splitting_helmert",
        "remove_lidar",
        "remove_sfm",
        "remove_helmert",
        "point_txt_lidar",
        "point_txt_sfm",
        "point_txt_helmert",
      ];
      updated.status = { ...prev.status };
      Object.keys(newDetail).forEach((key) => {
        if (key in statusKeys) {
          updated.status[key] = newDetail[key];
        } else if (key in prev) {
          updated[key] = newDetail[key];
        }
      });
      return updated;
    });
  };

  // View変更
  // 点群変更
  const updateCurrentPointCloud = (newType: Common.POINT_CLOUD_TYPE) => {
    setCurrentPointCloud(newType);
  };

  // 簡易点群除去ボタン
  type CustomIconProps = {
    path: string;
    disabled: boolean;
  };

  // プロジェクトステータス表示
  const toggleProjectState = (newVal?: boolean) => {
    newVal !== undefined || newVal != null
      ? setOpenProjectState(newVal)
      : setOpenProjectState((prev) => !prev);
  };

  // ビューモード変更
  const updateCurrentViewerMode = (newVal: EViewerMode) => {
    // console.log("updateCurrentViewerMode");
    setCurrentViewerMode(newVal);
  };

  // // 計算ステータス変更
  // const changeCalculationMode = (mode: ECalculationMode) => {
  //   setCalculationMode(mode);
  // };

  // ダイアログ表示
  const updateCurrentDialog = (name: EDialogType) => {
    setCurrentDialog(name);
  };

  const updateWhilePointCloudLoading = (val: boolean) => {
    setWhilePointCloudLoading(val);
  };

  const getProjectCookie = async () => {
    const abortController = new AbortController();

    try {
      await axios.get(
        `${config.serverHost}/api/v1/project/${projectId}/cookie`,
        {
          withCredentials: true,
          signal: abortController.signal,
        },
      );
    } catch (err) {
      // console.log(err);
    }
  };

  const forceBackToHome = () => {
    const search = sessionStorage.getItem("search");

    if (search) {
      const params = new URLSearchParams(search);
      navigate(`/?${params.toString()}`);
    } else {
      navigate("/");
    }
  };

  // projectDetail from /api/v1/project/{projectId}
  const getProjectDetail = async (shouldSetProcessIds?: boolean) => {
    try {
      await axios
        .get(`${config.serverHost}/api/v1/project/${projectId}`, {
          withCredentials: true,
        })
        .then((res: AxiosResponse<Common.ProjectDetail>) => {
          setProjectDetail(res.data);
          devLog("ProjectARView.projectDetail", {
            projectId: res.data?.id,
            isArView,
            is_ar: res.data?.status?.is_ar,
            las_file: res.data?.las_file || null,
            ifc_file: res.data?.ifc_file || null,
            design_file: res.data?.design_file || null,
            scm_file: (res.data as any)?.scm_file || null,
            scm_status: (res.data as any)?.scm_status || null,
          });

          // If this is a non-AR project opened via /ar/:id, redirect to /:id
          // instead of bouncing to home.
          if (!res.data?.status?.is_ar && isArView) {
            navigate(`/${projectId}${location.search || ""}`, {
              replace: true,
            });
            return;
          }

          if (shouldSetProcessIds !== false) {
            setProcessIds({
              ar: res.data.arProcessId,
            } as ProcessIds);
          }

          setProjectName(res?.data?.name);
          setGAValue(
            (prev) => ({ ...prev, jobsiteId: res?.data?.jobsiteId }) as GAObj,
          );
          document.title = res.data.name;
          setDetailDataLoadingStatus(LoadingStatus.Loaded); // loaded detail data -> show detail page
          setPix4dErrorMessage(res.data.pix4dErrorMessage);
          setPix4dErrorCode(res.data.pix4dErrorCode);
        })
        .catch((err) => {
          setErrorDetailsStatus(
            err.response?.status === resErrCode.Authority
              ? resErrCode.Authority
              : resErrCode.NotFound,
          );
          setDetailDataLoadingStatus(LoadingStatus.Error);
        });
    } catch (err) {
      setDetailDataLoadingStatus(LoadingStatus.Error);
    }
  };

  useEffect(() => {
    setGAValue(
      (prev) =>
        ({
          ...prev,
          userId: userInfo?.userId,
          corporationId: userInfo?.corporationId,
        }) as GAObj,
    );
  }, [userInfo]);

  const getUserSettings = async (shouldSetTheme: boolean = false) => {
    const apiUrl = `${config.serverHost}/api/v1/user/setting`;
    await axios
      .get(apiUrl, { withCredentials: true })
      .then((res: AxiosResponse<any>) => {
        setUserSettings(res.data);
        const projection = (res.data as userSetting)?.projectionDefault
          ? "perspective"
          : "orthographic";
        viewer.setProjectionMode(projection);

        if (shouldSetTheme && res.data.colorTheme !== themeMode) {
          setThemeMode(res.data.colorTheme);
        }
      });
  };

  // SuccessSnackbar
  const openSuccessSnackbar = (msg: string) => {
    setOpenSuccess(true);
    setMsgSuccess(msg);
  };

  const onCloseSuccessSnackbar = () => {
    setOpenSuccess(false);
  };

  // WarningSnackbar
  const openWarningSnackbar = (msg: string) => {
    setOpenWarning(true);
    setMsgWarning(msg);
  };

  const onCloseWarningSnackbar = () => {
    setOpenWarning(false);
  };

  // ErrorSnackbar
  const openErrorSnackbar = (msg: string) => {
    setOpenError(true);
    setMsgError(msg);
  };

  const onCloseErrorSnackbar = () => {
    setOpenError(false);
  };

  /*****************************************
   style
  ******************************************/
  const theme = useTheme();

  const customColor = {
    color: theme.palette.base.contrast,
  };

  // MuiPaper-root css
  const useStylesMuiPaper = makeStyles(() => ({
    root: {
      "&.MuiPaper-root,&.MuiPaper-elevation": {
        color: "#fff",
        backgroundcolor: "#121212",
      },
    },
  }));
  const classesMuiPaper = useStylesMuiPaper();

  // bodyのスタイルの上書き
  const useBodyStyles = makeStyles(() => ({
    body: {
      background: theme.palette.base.sub,
    },
  }));

  const classesBody = useBodyStyles();
  document.body.classList.add(classesBody.body);

  if (detailDataLoadingStatus === LoadingStatus.Error) {
    let resErrMsg: string = "Not Found";
    if (errorDetailsStatus === resErrCode.Authority) resErrMsg = "Not Allowed";
    return (
      <div>
        <h2
          style={{
            color: customColor.color,
            textAlign: "center",
            marginTop: "20px",
          }}
        >
          {errorDetailsStatus} {resErrMsg}
        </h2>
        <p style={{ color: "white", textAlign: "center" }}>
          <Link to="/">{t("BACK_TO_TOP")}</Link>
        </p>
      </div>
    );
  }

  // データロード中、ローディング画面表示
  if (detailDataLoadingStatus === LoadingStatus.Loading) {
    return (
      <div>
        <CircularProgress
          sx={{ position: "absolute", left: "50%", top: "50%" }}
        />
        <MsgSnackbar
          open={openSuccess}
          onClose={onCloseSuccessSnackbar}
          msg={msgSuccess}
        />
        <MsgErrSnackbar
          open={openError}
          onClose={onCloseErrorSnackbar}
          msg={msgError}
        />
      </div>
    );
  }

  return (
    <Box
      className={`${classesMuiPaper.root}`}
      sx={{
        height: !isIosView ? "calc(100vh - 42px)" : "100vh",
      }}
    >
      <ViewerContext.Provider value={viewer}>
        <ProjectDetailContext.Provider
          value={{
            projectDetail: projectDetail,
            getProjectDetail: getProjectDetail,
            userSettings: userSettings,
            updateProjectDetail: updateProjectDetail,
            displayType: EDisplayType.AR,
            viewer: viewer,
            currentPointCloud: currentPointCloud,
            updateCurrentPointCloud: updateCurrentPointCloud,
            currentViewerMode: currentViewerMode,
            updateCurrentViewerMode: updateCurrentViewerMode,
            isJapanese: isJapanese,
            whilePointCloudLoading: whilePointCloudLoading,
            updateWhilePointCloudLoading: updateWhilePointCloudLoading,
            isDialogType: currentDialog,
            updateCurrentDialog: updateCurrentDialog,
            detailTab: DETAIL_TAB.AR,
            openProjectState,
            setOpenProjectState,
            reloadPointCloud,
            isArView: isArView,
            isIosView: isIosView,
            showGsplat,
            setShowGsplat,
            showIfcPutObject,
            setShowIfcPutObject,
            selectedIfcObjectId,
            setSelectedIfcObjectId,
            selectedIfcObjectUrl,
            setSelectedIfcObjectUrl,
            selectedIfcObjectName,
            setSelectedIfcObjectName,
          }}
        >
          <PollingContext.Provider
            value={{
              processIds: processIds,
              updateProcessIds: updateProcessIds,
              callback: pollingCallback,
              setCallback: setPollingCallback,
            }}
          >
            <CoordinateContextProvider>
              <UpdateInfoContextProvider>
                <CalcContextProvider>
                  <RemoveContextProvider>
                    <UseSnackbarContext.Provider
                      value={{
                        openSuccess: openSuccessSnackbar,
                        onCloseSuccess: onCloseSuccessSnackbar,
                        openWarning: openWarningSnackbar,
                        onCloseWarning: onCloseWarningSnackbar,
                        openError: openErrorSnackbar,
                        onCloseError: onCloseErrorSnackbar,
                      }}
                    >
                      {!isIosView && <NavBar userInfo={userInfo} />}
                      <MenuBar />
                      <ToolBar
                        projectDetail={projectDetail}
                        currentViewerMode={currentViewerMode}
                      />
                      <Box
                        // IFC 配置はパネルアイテムの pointerdown ドラッグで行う
                        // (IfcDrawerContent.startPlacing)。3D プレビューがカーソルに追従。
                        sx={{
                          height: viewerHeight,
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                          width: "100%",
                          position: "relative",
                        }}
                      >
                        <PointCloudViewer ref={pointCloudViewerRef} />
                        {projectDetail?.gsx_file && showGsplat && (
                          <GaussianSplattingViewer />
                        )}
                        {!(
                          !!projectDetail.design_file ||
                          !!projectDetail.las_file ||
                          !!projectDetail.scm_file ||
                          !!projectDetail.gsx_file
                        ) && (
                          <div
                            style={{
                              textAlign: "center",
                              marginTop: "16px",
                              position: "absolute",
                              color: "gray",
                            }}
                          >
                            {t("PROJECT_AR_NO_FILE_TO_DISPLAY")}
                          </div>
                        )}
                        <IfcPlacementPanel />
                        <IfcObjectGizmo />
                      </Box>
                      <Q3DBottomDrawer
                        type={currentViewerMode}
                        open={bottomOpen}
                        setOpen={() => {
                          setBottomOpen(!bottomOpen);
                        }}
                      />
                      <ProjectState
                        openProjectState={
                          openProjectState && detailTab !== DETAIL_TAB.PHOTO
                        }
                        toggleProjectState={toggleProjectState}
                        toolBarShow={toolBarShow}
                        pix4dErrorMessage={pix4dErrorMessage}
                        pix4dErrorCode={pix4dErrorCode}
                      />
                      {/* dialogs */}
                      <ExportARData
                        open={currentDialog === EDialogType.EXPORT_DATA}
                        close={() => updateCurrentDialog(EDialogType.NONE)}
                      />
                      <ProjectDetailDialog
                        open={currentDialog === EDialogType.PROJECT_DETAIL}
                        close={() => updateCurrentDialog(EDialogType.NONE)}
                        setProjectName={setProjectName}
                        projectDetail={projectDetail}
                        updateProjectDetail={updateProjectDetail}
                      />
                      <SettingDialog
                        open={currentDialog === EDialogType.SETTING}
                        close={() => updateCurrentDialog(EDialogType.NONE)}
                        userId={userInfo?.userId}
                        isDetail={true}
                      />
                      <DeleteProjectDialog
                        openDialog={
                          currentDialog === EDialogType.PROJECT_DELETE
                        }
                        setOpenDialog={() =>
                          updateCurrentDialog(EDialogType.NONE)
                        }
                        projectID={projectDetail?.id}
                        projectName={projectDetail?.name}
                      />
                      <DeleteAllPointsDialog
                        open={currentDialog === EDialogType.DELETE_ALL_POINTS}
                        close={() => updateCurrentDialog(EDialogType.NONE)}
                      />
                      <ProcessCompletedDialog
                        open={openProcessCompletedDialog}
                        processResult={processResult}
                        handleClickClose={closeProcessCompletedDialog}
                      />
                      <MsgSnackbar
                        open={openSuccess}
                        onClose={onCloseSuccessSnackbar}
                        msg={msgSuccess}
                      />
                      <MsgErrSnackbar
                        open={openError}
                        onClose={onCloseErrorSnackbar}
                        msg={msgError}
                      />
                      <MsgWarnSnackbar
                        open={openWarnig}
                        onClose={onCloseWarningSnackbar}
                        msg={msgWarning}
                      />
                    </UseSnackbarContext.Provider>
                  </RemoveContextProvider>
                </CalcContextProvider>
              </UpdateInfoContextProvider>
            </CoordinateContextProvider>
          </PollingContext.Provider>
        </ProjectDetailContext.Provider>
      </ViewerContext.Provider>
    </Box>
  );
};

export default ProjectARView;
